import {
  AthenaResultsColumn,
  AthenaResults,
} from "components/athena/FetchAthenaResults";
import { groupFieldNamesByCommonFeature } from "components/athena/CsvColumnNameParsing";

import { getHighchartOptionsForCsv } from "./HighchartOptionsFromCsv";
import { HighchartPlotline } from "./HighchartOptions";

const timestamp_column_name = "timestamp_utc";

export const getHighchartOptionsFromAthena = (
  currentDataFields: string[],
  athenaData: AthenaResults,
  plotLines?: HighchartPlotline[]
) => {
  const currentDataFieldsByGroup = groupFieldNamesByCommonFeature(
    currentDataFields
  );
  const getColumnsInGroup = (
    columns: AthenaResultsColumn[],
    dataFieldsInGroup: string[]
  ) =>
    columns.filter(
      (x) =>
        x.name === timestamp_column_name ||
        dataFieldsInGroup.some((dataField) =>
          x.name.toLowerCase().startsWith(dataField.toLowerCase())
        )
    );

  return Object.values(currentDataFieldsByGroup).map((dataFieldsInGroup) =>
    getHighchartOptionsForCsv({
      parsedRows: athenaData.parsedRows,
      columns: getColumnsInGroup(athenaData.columns, dataFieldsInGroup),
      plotLines,
    })
  );
};
